import React from "react";
import { FaGithub, FaLinkedin, FaLinkedinIn } from "react-icons/fa";

const About = () => {
  return (
    <div id="about">
      <div className="mt-28 md:mx-8 mx-5">
        <div className="flex justify-center">
          <p className="text-xl mb-7 bg-stone-800 md:w-2/5 text-white p-2 rounded-lg">
            Get to know me!
          </p>
        </div>
        <div className="card  shadow-xl">
          <div className="card-body">
            <div>
              <img
                src="https://i.ibb.co/dJQr1Ds/portfolio.jpg"
                alt=""
                className="w-48 h-48 mx-auto rounded-full dark:bg-gray-500 "
              />
            </div>
            <p>
              I'm a Frontend Web Developer building the Front-end of Websites
              and I can also work on the back-end if needed. That leads to the
              success of the overall product. Check out some of my work in the
              Projects section.I am making some Relevant projects Some of the
              latest technologies are strongly used such as
              <p className="font-bold">
                React, Express.js, Firebase, Node.js, JavaScript, Api MongoDB
                and Tailwind
              </p>
              for design. Feel free If you want to know more details then
              contact me or follow me on
              <div>
                <a
                  className=" flex justify-center items-center"
                  href="https://www.linkedin.com/in/md-emon343/"
                >
                  <FaLinkedin className="text-xl mx-1"></FaLinkedin> LinkedIn
                </a>
              </div>
              and message me and check some project on my{" "}
              <a
                className="flex justify-center items-center"
                href="https://github.com/emon097"
              >
                <FaGithub className="text-xl mx-1"></FaGithub>
                GitHub
              </a>
              . May we discuss this Topic and Give some contributions to your
              company. Thank You
            </p>
            <div className="card-actions justify-center">
              <a href="#contact">
                <button className="btn mt-5 bg-stone-700 text-center">
                  Hiring Me
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
